import { ScorePills } from "./ScorePills";

export default ScorePills;
